<template>
  <div id="app">
    <LayoutTopNav />
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>
import LayoutTopNav from './components/LayoutTopNav.vue'
import SiteFooter from './components/SiteFooter.vue'
export default {
  name: 'App',
  components: {
    LayoutTopNav
    ,SiteFooter
  }
}
</script>

<style>
/* App.vue 全局样式已移至 styles.css */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
